import React, { Component } from "react";
import { DateObject } from "react-multi-date-picker";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleMonthYearPicker from "../../../../../modules/SimpleMonthYearPicker";
import { TAB_CODE, TIPE_PENGAJUAN_CONSTANT } from "../../constant";
import InputWithButton from "../inputWithButton";
import { ACTIVITY_TYPE } from "../../../../common/Constants";
import * as R from 'ramda';

export default class ClaimInformationSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredNamaVariantOptions: this.props.namaVariantOptions,
      filteredKodeVariantOptions: this.props.kodeVariantOptions,
      kodeWarnaFiltered: this.props.kodeWarnaOptions,
      namaWarnaFiltered: this.props.namaWarnaOptions,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.namaVariantOptions !== this.props.namaVariantOptions ||
      prevProps.kodeVariantOptions !== this.props.kodeVariantOptions
    ) {
      this.setState({
        filteredNamaVariantOptions: this.props.namaVariantOptions,
        filteredKodeVariantOptions: this.props.kodeVariantOptions
      });
    }
    if (
      prevProps.kodeWarnaOptions !== this.props.kodeWarnaOptions ||
      prevProps.namaWarnaOptions !== this.props.namaWarnaOptions
    ) {
      this.setState({
        kodeWarnaFiltered: this.props.kodeWarnaOptions,
        namaWarnaFiltered: this.props.namaWarnaOptions
      });
    }
  }

  handleCheckNoka = () => {
    const { onCheckUnit, controls } = this.props;
    onCheckUnit({ noka: controls?.nomorRangka?.value, nosin: null });
  };

  handleCheckNosin = () => {
    const { onCheckUnit, controls } = this.props;
    onCheckUnit({ noka: null, nosin: controls?.nomorMesin?.value });
  };

  getTahunProduksi = (yearString) => {
    if (!yearString) return null;
    const year = parseInt(yearString, 10);
    return new DateObject(new Date(year, 0, 1)); // month = 0 (January)
  };

  checkIsDisabled = () => {
    const {activityType,isDisableSpesificField} = this.props;
    const isView = activityType === ACTIVITY_TYPE.VIEW;
    const isDelete = activityType === ACTIVITY_TYPE.DELETE;
    const isUpdate = activityType === ACTIVITY_TYPE.UPDATE;
    if(isView || isDelete){
      return isView || isDelete
    }
    if(isUpdate){
      return isDisableSpesificField;
    }
  }

  setValueTipePengajuan = (name, value) => {
    const { setValue, onPopulateC1Data } = this.props;
    setValue(name, value);
    if (R.equals(value?.value, "C1")) {
      onPopulateC1Data();
    }
  }

  render() {
    const {
      kodeVariantOptions,
      namaVariantOptions,
      namaWarnaOptions,
      setValue,
      controls,
      kodeWarnaOptions,
      onOpenModalBBM,
      onOpenModalBKKBBK,
      placeholderIdClaim,
      namaPelaporOptions,
      errors,
      tabCode,
      activityType,
      onCancelAutoPopulate,
      isAutoPopulatedData
    } = this.props;
    const isView = activityType === ACTIVITY_TYPE.VIEW;
    const isDelete = activityType === ACTIVITY_TYPE.DELETE;
    return (
      <React.Fragment>
        <div className="grid grid-3x gap-30px">
          <div className="column-1">
            <SimpleInput
              id="id_input_id_claim"
              label="ID Claim"
              name="idClaim"
              value={controls?.idClaim?.value || placeholderIdClaim}
              readOnly
            />
            <SimpleDate
              id="id_input_tanggal_claim"
              label="Tanggal Claim"
              name="tanggalClaim"
              readOnly
              // disabled={isDelete}
              disabled={true}
              date={controls?.tanggalClaim?.value}
            />
            <SimpleInput
              id="id_input_nomor_claim"
              label="Nomor Claim"
              name="nomorClaim"
              value={controls?.nomorClaim?.value}
              mandatory
              readOnly={this.checkIsDisabled()}
              errorMessage={errors?.nomorClaim}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleDDL
              id="id_ddl_tipe_pengajuan"
              label="Tipe Pengajuan"
              name="tipePengajuan"
              box="search"
              mandatory
              isSearchable={false}
              readOnly={this.checkIsDisabled()}
              errorMessage={errors?.tipePengajuan}
              options={TIPE_PENGAJUAN_CONSTANT}
              value={controls?.tipePengajuan?.value}
              onChange={(value, { name }) => this.setValueTipePengajuan(name, value)}
            />
            <InputWithButton
              id="id_nomor_bbm_pencairan"
              label="Nomor BBM Pencairan"
              disableInput
              disableButton={(isView && tabCode === TAB_CODE.BELUM_PEMENUHAN) || isDelete}
              icon={<i className="fa fa-md fa-search" />}
              name="noBBM"
              onClickIcon={onOpenModalBBM}
              value={controls?.noBBM?.value}
            />
          </div>

          {/* === Row 2 === */}
          <div className="column-2">
            <SimpleInput
              id="id_input_id_hotline"
              label="ID Hotline"
              name="idHotline"
              readOnly
              value={controls?.idHotline?.value}
            />
            <div style={{ paddingBlock: "28px" }}>
              <SimpleCheckBox
                id="check_box_non_hotline"
                checked={controls?.isNonHotline?.value}
                name="isNonHotline"
                label="NON-HOTLINE"
                disabled={
                  controls?.idHotline?.value ||
                  (isView && tabCode === TAB_CODE.BELUM_CAIR) ||
                  isDelete
                }
                onChange={({ target }) => setValue(target.name, target.checked)}
              />
            </div>
            <InputWithButton
              id="id_input_bkk_bbkpembelian"
              label="Nomor BKK/BBK Pembelian"
              icon={<i className="fa fa-md fa-search" />}
              name="noBkkBBk"
              disableInput
              value={controls?.nomorPembelian?.value}
              disableButton={!controls?.isNonHotline?.value || (isView && tabCode === TAB_CODE.BELUM_CAIR)}
              onClickIcon={() => {
                if (!controls?.isNonHotline?.value || (isView && tabCode === TAB_CODE.BELUM_CAIR)) {
                  return;
                }
                onOpenModalBKKBBK();
              }}
            />
            <SimpleMonthYearPicker
              id="id_input_tahun_produksi"
              label="Tahun Produksi Unit"
              name="tahunProduksi"
              containerclassname="flex-1"
              onlyYearPicker
              mandatory
              readOnly={this.checkIsDisabled()}
              errorMessage={errors?.tahunProduksi}
              containerStyle={{ width: "100%" }}
              placeholder="YYYY"
              value={this.getTahunProduksi(controls?.tahunProduksi?.value)}
              onChange={(value) =>
                setValue("tahunProduksi", value?.format("YYYY"))
              }
            />
            <SimpleDDL
              id="id_ddl_nama_pelapor"
              label="Nama Pelapor"
              name="namaPelapor"
              mandatory
              readOnly={this.checkIsDisabled()}
              errorMessage={errors?.namaPelapor}
              options={namaPelaporOptions}
              box="search"
              value={controls?.namaPelapor?.value}
              onChange={(value, { name }) => setValue(name, value)}
            />
          </div>

          <div className="column-3">
            <InputWithButton
              id="id_input_no_rangka"
              label="Nomor Rangka"
              buttonText="CEK"
              mandatory
              name="nomorRangka"
              disableButton={this.checkIsDisabled() || isAutoPopulatedData}
              disableInput={this.checkIsDisabled() || isAutoPopulatedData}
              errorMessage={errors?.nomorRangka}
              value={controls?.nomorRangka?.value}
              onClickIcon={this.handleCheckNoka}
              onClear={() => !controls?.nomorRangka?.value ? null : onCancelAutoPopulate("noka")}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <InputWithButton
              id="id_input_no_mesin"
              label="Nomor Mesin"
              name="nomorMesin"
              errorMessage={errors?.nomorMesin}
              buttonText="CEK"
              mandatory
              disableButton={this.checkIsDisabled() || isAutoPopulatedData}
              disableInput={this.checkIsDisabled() || isAutoPopulatedData}
              value={controls?.nomorMesin?.value}
              onClickIcon={this.handleCheckNosin}
              onChange={({ target }) => setValue(target.name, target.value)}
              onClear={() => !controls?.nomorMesin?.value ? null : onCancelAutoPopulate("nosin")}
            />
            <SimpleDDL
              id="id_ddl_kode_varian"
              label="Kode Varian"
              name="kodeVarian"
              mandatory
              readOnly={this.checkIsDisabled() || isAutoPopulatedData}
              errorMessage={errors?.kodeVarian}
              options={this.state.filteredKodeVariantOptions}
              value={controls?.kodeVarian?.value}
              box="search"
              isClearable
              onChange={(value, { name }) => {
                if(value === null){
                  setValue("kodeVarian", null);
                  setValue("namaVarian", null);
                  setValue("kodeWarna", null);
                  setValue("namaWarna", null);

                  this.setState({
                    filteredKodeVariantOptions: kodeVariantOptions,
                    filteredNamaVariantOptions: namaVariantOptions,
                    namaWarnaFiltered: [],
                    kodeWarnaFiltered: []
                  });
                }

                setValue(name, value);
                setValue("kodeWarna", null);
                setValue("namaWarna", null);

                const selected = kodeVariantOptions.find(
                  (item) => item.value === value?.value
                );

                if (selected) {
                  setValue("namaVarian", {
                    label: selected.namaVariant,
                    value: selected.namaVariant
                  });

                  const filtered = namaVariantOptions.filter(
                    (item) => item.kodeVariant === selected.value
                  );
                  this.setState({ 
                    filteredNamaVariantOptions: filtered,
                    filteredKodeVariantOptions: kodeVariantOptions 
                  });
                }
              }}
            />
            {/* <SimpleDDL
              id="id_ddl_kode_varian"
              label="Kode Varian"
              name="kodeVarian"
              mandatory
              readOnly={this.checkIsDisabled() || isAutoPopulatedData}
              errorMessage={errors?.kodeVarian}
              options={kodeVariantOptions}
              value={controls?.kodeVarian?.value}
              box="search"
              onChange={(value, { name }) => setValue(name, value)}
            /> */}
            <SimpleDDL
              id="id_ddl_nama_varian"
              label="Nama Varian"
              name="namaVarian"
              mandatory
              readOnly={this.checkIsDisabled() || isAutoPopulatedData}
              options={this.state.filteredNamaVariantOptions}
              box="search"
              errorMessage={errors?.namaVarian}
              value={controls?.namaVarian?.value}
              isClearable
              onChange={(value, { name }) => {
                 if(value === null){
                  setValue("kodeVarian", null);
                  setValue("namaVarian", null);
                  setValue("kodeWarna", null);
                  setValue("namaWarna", null);

                  this.setState({
                    filteredKodeVariantOptions: kodeVariantOptions,
                    filteredNamaVariantOptions: namaVariantOptions,
                    namaWarnaFiltered: [],
                    kodeWarnaFiltered: []
                  });
                }

                setValue(name, value);
                setValue("kodeWarna", null);
                setValue("namaWarna", null);

                const selected = namaVariantOptions.find(
                  (item) => item.value === value?.value
                );

                if (selected) {
                  setValue("kodeVarian", {
                    label: selected.kodeVariant,
                    value: selected.kodeVariant
                  });

                  const filtered = kodeVariantOptions.filter(
                    (item) => item.value === selected.kodeVariant
                  );
                  this.setState({ 
                    filteredKodeVariantOptions: filtered, 
                    filteredNamaVariantOptions: namaVariantOptions
                   })
                }
              }}
            />
            {/* <SimpleDDL
              id="id_ddl_nama_varian"
              label="Nama Varian"
              name="namaVarian"
              mandatory
              readOnly={this.checkIsDisabled() || isAutoPopulatedData}
              options={namaVariantOptions}
              box="search"
              errorMessage={errors?.namaVarian}
              value={controls?.namaVarian?.value}
              onChange={(value, { name }) => setValue(name, value)}
            /> */}
            <SimpleDDL
              id="id_ddl_kode_warna"
              label="Kode Warna"
              name="kodeWarna"
              box="search"
              mandatory
              readOnly={this.checkIsDisabled() || isAutoPopulatedData}
              errorMessage={errors?.kodeWarna}
              options={this.state.kodeWarnaFiltered}
              value={controls?.kodeWarna?.value}
              isClearable
              onChange={(value, { name }) => {
                 if(value === null){
                  setValue("namaWarna", null);
                  setValue("kodeWarna", null);

                  this.setState({
                    namaWarnaFiltered: namaWarnaOptions,
                    kodeWarnaFiltered: kodeWarnaOptions
                  });
                }

                setValue(name, value);

                const selected = kodeWarnaOptions.find(
                  (item) => item.value === value?.value
                );
                
                if (selected) {
                  setValue("namaWarna", {
                    label: selected.namaWarnaKomersil,
                    value: selected.id
                  });

                  const filtered = namaWarnaOptions.filter(
                    (item) => item.kodeWarna === selected.value
                  );
                  this.setState({ 
                    namaWarnaFiltered: filtered,
                    kodeWarnaFiltered: kodeWarnaOptions
                   });
                }
              }}
            />
            {/* <SimpleDDL
              id="id_ddl_kode_warna"
              label="Kode Warna"
              name="kodeWarna"
              box="search"
              mandatory
              readOnly={this.checkIsDisabled() || isAutoPopulatedData}
              errorMessage={errors?.kodeWarna}
              options={kodeWarnaOptions}
              value={controls?.kodeWarna?.value}
              onChange={(value, { name }) => setValue(name, value)}
            /> */}
            <SimpleDDL
              id="id_ddl_nama_warna"
              label="Nama Warna"
              mandatory
              name="namaWarna"
              errorMessage={errors?.namaWarna}
              box="search"
              readOnly={this.checkIsDisabled() || isAutoPopulatedData}
              options={this.state.namaWarnaFiltered}
              value={controls?.namaWarna?.value}
              isClearable
              onChange={(value, { name }) => {
                if(value === null){
                  setValue("namaWarna", null);
                  setValue("kodeWarna", null);

                  this.setState({
                    namaWarnaFiltered: namaWarnaOptions,
                    kodeWarnaFiltered: kodeWarnaOptions
                  });
                }
                setValue(name, value);

                const selected = namaWarnaOptions.find(
                  (item) => item.value === value?.value
                );

                if (selected) {
                  setValue("kodeWarna", {
                    label: selected.kodeWarna,
                    value: selected.kodeWarna
                  });

                  const filtered = kodeWarnaOptions.filter(
                    (item) => item.value === selected.kodeWarna
                  );
                  this.setState({ 
                    kodeWarnaFiltered: filtered, 
                    namaWarnaFiltered: namaWarnaOptions
                   });
                }

              }}
            />
            {/* <SimpleDDL
              id="id_ddl_nama_warna"
              label="Nama Warna"
              mandatory
              name="namaWarna"
              errorMessage={errors?.namaWarna}
              box="search"
              readOnly={this.checkIsDisabled() || isAutoPopulatedData}
              options={namaWarnaOptions}
              value={controls?.namaWarna?.value}
              onChange={(value, { name }) => setValue(name, value)}
            /> */}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
